import Icon from '../components/Icon.vue'

Icon.register({
  pallet: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M144 256c-8.8 0-16-7.2-16-16v-224c0-8.8 7.2-16 16-16h112v128l64-32 64 32v-128h112c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16h-352zM624 384h-48v64h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-64h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h608c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM288 448v-64h-160v64h160zM512 448v-64h-160v64h160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pallet.js
// module id = 1607
// module chunks = 0